/**
 * Labstep
 *
 * @module components/Folder/ToggleIncludeSubfolders
 * @desc ToggleIncludeSubfolders showing folders for ExperimentWorkflow or ProtocolCollection type
 */

import { withUserSettings } from 'labstep-web/containers/UserSettings';
import { Checkbox } from 'labstep-web/core/Checkbox';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { FolderToggleIncludeSubfoldersProps } from './types';

export const FolderToggleIncludeSubfolders: React.FC<
  FolderToggleIncludeSubfoldersProps
> = ({
  folderType,
  folderIncludeSubfolders,
  setFolderIncludeSubfolders,
}) => {
  const handleToggle = () => {
    setFolderIncludeSubfolders(folderType, !folderIncludeSubfolders);
  };

  return (
    <Checkbox
      label={`Show ${getHumanReadableEntityName(folderType, true, false)} in sub-collections`}
      checked={folderIncludeSubfolders}
      onClick={handleToggle}
      toggle
      optimistic
    />
  );
};

export default withUserSettings(FolderToggleIncludeSubfolders);
